import {Component} from '@angular/core';

@Component({
  selector: 'app-progress-overlay',
  template: `
    <div class="overlay">
      <mat-spinner color="primary" [diameter]="50"></mat-spinner>
    </div>
  `,
  styles: [`
    .overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `]
})

export class ProgressOverlayComponent {

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/progress-overlay/progress-overlay.component.ts